import styled from 'styled-components'

import {
    IconChatOutline,
    IconHeartFill,
    IconHeartOutline,
    IconLiveCircleTip,
    IconLockFill,
    IconPostStats
} from 'assets/svg/sprite'
import colors from 'styles/colors'

type TypeАctionIcon =
    | 'ChatOutline'
    | 'HeartFill'
    | 'HeartOutline'
    | 'LockFill'
    | 'PostStats'
    | 'LiveCircleTip'
type TypeLocation = 'story' | 'post'

export interface IStoryActionProps {
    icon: TypeАctionIcon
    text?: string
    onClickAction?: () => void
    location?: TypeLocation
}

export const StoryAction = ({
    icon,
    text,
    onClickAction
}: IStoryActionProps) => {
    const renderIconComponent = (icon: TypeАctionIcon): JSX.Element => {
        switch (icon) {
            case 'HeartFill':
                return <IconHeartFill />
            case 'HeartOutline':
                return <IconHeartOutline color='#FFFFFF' />
            case 'LockFill':
                return <IconLockFill />
            case 'ChatOutline':
                return <IconChatOutline color='#FFFFFF' />
            case 'PostStats':
                return <IconPostStats />
            case 'LiveCircleTip':
                return <IconLiveCircleTip color='#FFFFFF' />

            default:
                return <IconHeartOutline />
        }
    }

    return (
        <StoryActionContainer
            onClick={event => {
                event.stopPropagation()
                onClickAction?.()
            }}
            $clickable={onClickAction !== undefined}
        >
            <div>{renderIconComponent(icon)}</div>
            {!!text && <StoryActionText>{text}</StoryActionText>}
        </StoryActionContainer>
    )
}
interface ContainerProps {
    $clickable?: boolean
}

const StoryActionContainer = styled.div<ContainerProps>`
    align-items: center;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 2.8rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 1rem;
    min-width: 5.6rem;
    padding: 1.6rem;
    text-align: center;
    pointer-events: all;
    ${props => (props.$clickable ? '' : ' pointer-events: none;')}
`
const StoryActionText = styled.p`
    color: ${colors.white} !important;
    font-family: SF-Pro-Display, sans-serif !important;
    font-size: 1.1rem !important;
    font-style: normal !important;
    font-weight: 400 !important;
    letter-spacing: 0.04em !important;
    margin: 3px 0 0 !important;
    text-align: center !important;
`
